import { AddressReverseResult } from '../dataSources/dataforsyningen/AddressReverse'
import {
  FETCHING_ADDRESS_FAILURE, FETCHING_ADDRESS_STARTED, FETCHING_ADDRESS_SUCCESS,
  FETCHING_IMAGE_SUCCESS, FETCHING_IMAGE_STARTED, FETCHING_IMAGE_FAILURE,
  SET_MAX_DEPTH, SET_COORDINATES, CLEAR_STATE, CLEAR_ADDRESS_STATE, CLEAR_IMAGE_STATE
} from '../actions/VirtualBoreholeInfoActions'
import { CallResult, MessageAction, DataAction, BaseAction } from '../CustomTypes'

export interface VirtualBoreholeInfoState {
  fetchAddressStatus: CallResult
  fetchAddressError: string
  addressInfo?: AddressReverseResult

  fetchImageStatus: CallResult
  fetchImageError: string
  virtualBoreholePng: string

  maxDepth: number
  coordinates: number[]
}

const initialAddressState = {
  fetchAddressStatus: CallResult.Initial,
  fetchAddressError: '',
  addressInfo: undefined
}

const initialImageState = {
  fetchImageStatus: CallResult.Initial,
  fetchImageError: '',
  virtualBoreholePng: ''
}

export const virtualBoreholeInfoStateInitial: VirtualBoreholeInfoState = {
  ...initialAddressState,
  ...initialImageState,
  maxDepth: -130,
  coordinates: [-1, -1]
}

export function virtualBoreholeInfoReducer (
  state: VirtualBoreholeInfoState = virtualBoreholeInfoStateInitial, // eslint-disable-line @typescript-eslint/default-param-last
  action: BaseAction): VirtualBoreholeInfoState {
  switch (action.type) {
    case FETCHING_ADDRESS_STARTED: {
      return {
        ...state,
        fetchAddressStatus: CallResult.Running
      }
    }
    case FETCHING_ADDRESS_FAILURE: {
      const a = action as MessageAction
      return {
        ...state,
        fetchAddressStatus: CallResult.Failed,
        fetchAddressError: a.message
      }
    }
    case FETCHING_ADDRESS_SUCCESS: {
      const a = action as DataAction<AddressReverseResult>
      return {
        ...state,
        fetchAddressStatus: CallResult.Succeeded,
        addressInfo: a.data
      }
    }
    case FETCHING_IMAGE_STARTED: {
      return {
        ...state,
        fetchImageStatus: CallResult.Running
      }
    }
    case FETCHING_IMAGE_FAILURE: {
      const a = action as MessageAction
      return {
        ...state,
        fetchImageStatus: CallResult.Failed,
        fetchImageError: a.message
      }
    }
    case FETCHING_IMAGE_SUCCESS: {
      const a = action as DataAction<string>
      return {
        ...state,
        fetchImageStatus: CallResult.Succeeded,
        virtualBoreholePng: a.data
      }
    }
    case SET_MAX_DEPTH: {
      const a = action as DataAction<number>
      return {
        ...state,
        maxDepth: a.data
      }
    }
    case SET_COORDINATES: {
      const a = action as DataAction<number[]>
      return {
        ...state,
        coordinates: a.data
      }
    }
    case CLEAR_ADDRESS_STATE: {
      return {
        ...state,
        ...initialAddressState
      }
    }
    case CLEAR_IMAGE_STATE: {
      return {
        ...state,
        ...initialImageState
      }
    }
    case CLEAR_STATE: {
      return {
        ...state,
        fetchAddressStatus: CallResult.Initial,
        fetchAddressError: '',
        addressInfo: undefined,
        fetchImageStatus: CallResult.Initial,
        fetchImageError: '',
        virtualBoreholePng: '',
        coordinates: [-1, -1]
      }
    }
    default:
      return state
  }
}
